import { PlusOutlined, MinusOutlined } from '@ant-design/icons'
import { Collapse } from '@lockerpm/design'
import { useTranslation } from 'next-i18next'

export default function FrequentlyQuestion() {
  const { t } = useTranslation('password-generator')

  return (
    <section className="py-12 lg:py-24 password-generator-frenquently-question">
      <div className="max-w-[1280px] xl:px-0 px-5 mx-auto lg:flex justify-between xl:gap-20 lg:gap-10 flex-col md:flex-row">
        <h2 className="text-display-md lg:text-display-lg font-semibold text-heading mb-5 max-w-[480px] flex-shrink-0">
          Câu hỏi thường gặp
        </h2>
        <Collapse
          ghost
          defaultActiveKey={[0, 1, 2]}
          className="flex-1"
          expandIcon={(p) =>
            p.isActive ? (
              <PlusOutlined
                style={{ fontSize: '1.5rem', lineHeight: '2rem', marginTop: 5 }}
                className="text-primary"
              />
            ) : (
              <MinusOutlined
                className="text-primary"
                style={{ fontSize: '1.5rem', lineHeight: '2rem', marginTop: 5 }}
              />
            )
          }
        >
          {t('questions.items', { returnObjects: true }).map((item, index) => (
            <Collapse.Panel
              key={index}
              header={<p className="text-black lg:text-display-xs font-semibold">{item.title}</p>}
              className="border border-solid border-t-0 border-l-0 border-r-0 border-[#D9D9D9] px-0 pt-6 lg:pt-12 first:pt-0 last:border-none"
            >
              <div className="pr-12">
                <p className="text-md text-[#344054] mb-2">{item.desc}</p>
                {item.desc_1 ? <p className="text-md text-[#344054] mb-2">{item.desc_1}</p> : null}
                {item.desc_2 ? <p className="text-md text-[#344054]">{item.desc_2}</p> : null}
              </div>
            </Collapse.Panel>
          ))}
        </Collapse>
      </div>
    </section>
  )
}
